











































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CrimePoint } from '../models/CrimePoint';
import ChartDoughnutCrime from '@/components/ChartDoughnutCrime.vue';
import L from 'leaflet';
import * as esri from 'esri-leaflet';

@Component({
    components: {
        ChartDoughnutCrime,
    },
})
export default class CrimePanel extends Vue {

    public widthThresholdValue: number = 768;
    public showDialog: boolean = false;
    public isCrimePanelReady: boolean = false;
    public crimeRecordsTable: esri.FeatureLayer | null = null;
    public currentCrimes: any = null; // this could probably become CrimePoint[]

    public crimeDataCollection: any = {};
    public crimeData: number[] = [];
    public crimeLabels: string[] = [];
    public crimeColours = ['#D62728', '#9467BD', '#E377C2', '#BCBD22', '#17BECF'];
    public options = {
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                animateRotate: false,
            },
            legend: {
                position: 'bottom',
            }, elements: {
                center: {
                    text: '',
                    color: '#000',
                    fontStyle: 'Arial',
                    sidePadding: 20,
                    minFontSize: 13,
                    lineHeight: 25,
                },
            },
        };
    public pagination = {
        rowsPerPage: 100,
        rowsNumber: 100,
    };

    public crimeColumns = [
        { name: 'EventDate', align: 'left', label: 'Date', field: 'EventDate', format: (val: number) => `${this.getFormatedDateFromEpoch(val)}`, style: 'width: 40px;', sortable: true},
        { name: 'Type', align: 'left', label: 'Crime',  field: 'Type', style: 'width: 40px;', sortable: true },
    ];

    get crimeTableData(): string[] {
        const dataArray = [];
        for (let i = 0; i < this.currentCrimes.length; i++) {
            dataArray.push(this.currentCrimes[i].properties);
        }
        return dataArray;
    }

    get isMobile(): boolean {
        return this.$q.screen.width <= this.widthThresholdValue;
    }

    get config() {
        return this.$store.state.config;
    }

    get selectedCrime(): CrimePoint {
        return this.$store.state.layers.selectedCrime;
    }

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'initCrimeLayer') {
            if (!this.isCrimePanelReady) {
                this.initCrimeRecordsLayer();
            }
        }

        if (action.type === 'showCrimeDialog') {
            this.onShowDialog();
        }
    });

    @Watch('selectedCrime', { immediate: false, deep: false })
    public selectedCrimeChanged(value: CrimePoint, oldValue: CrimePoint) {
        if (value !== oldValue) {
            this.onSelectedCrimeChanged();
        }
    }

    public getFormatedDateFromEpoch(dateStr: number) {
        const date = new Date(dateStr);
        const year = date.getFullYear();
        let month = (1 + date.getMonth()).toString();
        month = month.length > 1 ? month : '0' + month;
        let day = date.getDate().toString();
        day = day.length > 1 ? day : '0' + day;

        return year + '-' + month + '-' + day;
    }

    public onShowDialog() {
        this.showDialog = true;
    }

    public mounted() {
        console.log('CrimePanel: mounted()');
        this.crimeLabels = [];
    }

    public initCrimeRecordsLayer() {
        console.log('CrimePanel: initCrimeRecordsLayer');
        this.crimeRecordsTable = esri.featureLayer({
            url: this.config.CrimeRecordsTable.url,
            proxy: this.config.proxy.url,
        });
        this.isCrimePanelReady = true;
    }

    public onSelectedCrimeChanged() {
        console.log('onSelectedCrimeChanged');
        if (this.crimeRecordsTable) {
            this.crimeRecordsTable
            .query()
            .where('CrimePointID=' + this.selectedCrime.CrimePointID)
            .run((error, featureCollection) => {
                this.currentCrimes = featureCollection.features;
                this.crimeLabels = [];
                this.crimeData = [];

                for (let i = 0; i < this.currentCrimes.length; i++) {
                    if (this.crimeLabels.indexOf(this.currentCrimes[i].properties.Type)  === -1) {
                        this.crimeLabels.push(this.currentCrimes[i].properties.Type);
                        this.crimeData.push(1);
                    } else {
                        const index = this.crimeLabels.indexOf(this.currentCrimes[i].properties.Type);
                        this.crimeData[index] = this.crimeData[index] + 1;
                    }
                }

                this.crimeDataCollection = {
                    labels: this.crimeLabels,
                    datasets: [
                        {
                        label: '',
                        backgroundColor: this.crimeColours,
                        data: this.crimeData,
                        }],
                };
                this.options.elements.center.text = 'Total crimes: ' + this.currentCrimes.length;
            });
        }
    }
}

